import React from "react";

const CookieBanner = ({ onClose }) => {
  // Check if cookies have already been accepted
  const cookiesAccepted = localStorage.getItem('cookiesAccepted');
  
  if (cookiesAccepted) {
    return null;
  }

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    onClose();
  };

  const handlePersonalize = () => {
    localStorage.setItem('cookiesAccepted', 'personalized');
    onClose();
  };

  const handleContinue = () => {
    localStorage.setItem('cookiesAccepted', 'minimal');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-2xl mx-4">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">Cookie policy</h3>
        <p className="text-gray-700 mb-6">
          Questo sito utilizza i <strong>cookies</strong>, anche di <strong>terze parti</strong>, per migliorare l'esperienza
          di navigazione e adeguare le pubblicità alle tue preferenze come indicato
          nella <strong>Cookies Policy</strong>. Se acconsenti al trattamento di tali cookies o altri
          strumenti analoghi clicca su <strong>"Accetta"</strong> oppure personalizza le tue preferenze
          cliccando su <strong>"Personalizza"</strong>. Se invece chiudi questo banner cliccando su
          "Continua senza accettare", la tua navigazione continuerà in assenza di cookie
          o di altri strumenti analoghi diversi da quelli strettamente necessari.
        </p>
        <div className="flex space-x-4">
          <button
            onClick={handlePersonalize}
            className="bg-black text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
          >
            PERSONALIZZA
          </button>
          <button
            onClick={handleAccept}
            className="bg-black text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
          >
            ACCETTA
          </button>
        </div>
        <button
          onClick={handleContinue}
          className="block mx-auto mt-4 text-gray-600 hover:text-gray-800 text-sm"
        >
          CONTINUA SENZA ACCETTARE
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;